/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Nav_PaymentsInputs */

const en_admin_nav_payments = /** @type {(inputs: Admin_Nav_PaymentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payments`)
};

const zh_admin_nav_payments = /** @type {(inputs: Admin_Nav_PaymentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支付`)
};

/**
* | output |
* | --- |
* | "Payments" |
*
* @param {Admin_Nav_PaymentsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_nav_payments = /** @type {((inputs?: Admin_Nav_PaymentsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Nav_PaymentsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_nav_payments(inputs)
	return zh_admin_nav_payments(inputs)
});
export { admin_nav_payments as "admin.nav.payments" }